import cx from 'classnames';
import PropTypes from 'prop-types';

import './DropdownWrapper.scss';

const propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  isOpened: PropTypes.bool,
};

const defaultProps = {
  children: null,
  fullWidth: false,
  isOpened: false,
};

function DropdownWrapper(props) {
  const { children, fullWidth, isOpened, ...rest } = props;
  const className = cx('DropdownWrapper', {
    'DropdownWrapper--full-width': fullWidth,
    'DropdownWrapper--opened': isOpened,
  });

  return (
    <div {...rest} className={className}>
      {children}
    </div>
  );
}

DropdownWrapper.propTypes = propTypes;
DropdownWrapper.defaultProps = defaultProps;

export default DropdownWrapper;
